<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <!--<Wxts :wxtsList="wxtsList" />-->

    <el-form ref="form" :model="form" :label-width="labelWidth">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />

      <el-form-item label="出车费用表设置" prop="cost" :label-width="labelWidth" class="item">
        <el-checkbox-group class="list" v-model="checkList" @change="onCheckChange">
          <el-checkbox class="item" v-for="(c, i) in checkOptions" :key="'itemm' + i" :label="c.value">
            {{ c.label }}
          </el-checkbox>
        </el-checkbox-group>
        <span class="tips">勾选的类型才会显示在出车费用表中</span>
      </el-form-item>

      <el-form-item label="是否计入固定费用" prop="fixed_pay" :label-width="labelWidth" class="item">
        <el-checkbox-group class="list" v-model="checkList2" @change="onCheckChange2">
          <el-checkbox class="item" v-for="(c, i) in checkOptions2" :key="'itemm2' + i" :label="c.value">
            {{ c.label }}
          </el-checkbox>
        </el-checkbox-group>
        <span class="tips">勾选的类型将计入固定费支出表中</span>
      </el-form-item>

      <el-form-item label="是否加入车辆年检" prop="inspection" :label-width="labelWidth" class="item">
        <el-checkbox-group class="list" v-model="checkList3" @change="onCheckChange3">
          <el-checkbox class="item" v-for="(c, i) in checkOptions3" :disabled="c.disabled" :key="'itemm3' + i"
            :label="c.value">
            {{ c.label }}
          </el-checkbox>
        </el-checkbox-group>
        <span class="tips">勾选的类型将加入车辆年检列表中</span>
      </el-form-item>
    </el-form>

    <div class="btns">
      <el-button type="primary" @click="onSubmit">保 存</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FinanceBaseSalary",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'system',
      breadcrumb: [
        { name: "系统设置" },
        { name: "基础设置" },
      ],
      formCtrl: [
        {
          label: "是否允许连续派单",
          keyName: "is_continued",
          type: "radio",
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 0 },
          ],
        },
      ],
      checkList: [],
      checkList2: [],
      checkList3: ['1'],
      checkOptions: [
        { label: '车辆加油', value: '1' },
        { label: '出车费用', value: '2' },
        { label: '里程登记', value: '3' },
      ],
      checkOptions2: [
        { label: '车辆年检', value: '1' },
        { label: '违章罚款', value: '2' },
      ],
      checkOptions3: [
        { label: '车头', value: '1', disabled: true },
        { label: '挂车', value: '2' },
      ],
    };
  },
  methods: {
    onCheckChange(v) {
      console.log(v)
      if (v && v.length) {
        const arr = [...v]
        this.form.cost = arr.join(',')
      } else {
        this.form.cost = null
      }
      // console.log(this.checkList)
      // console.log(this.form)
    },
    onCheckChange2(v) {
      console.log(v)
      if (v && v.length) {
        const arr = [...v]
        this.form.fixed_pay = arr.join(',')
      } else {
        this.form.fixed_pay = null
      }
      console.log('checkList2', this.checkList2)
      // console.log(this.form)
    },
    onCheckChange3(v) {
      console.log(v)
      if (v && v.length) {
        const arr = [...v]
        this.form.inspection = arr.join(',')
      } else {
        this.form.inspection = '1'
      }
      // console.log(this.checkList3)
      // console.log(this.form)
    },
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/index`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          this.detail = data
          this.formCtrl.map(v => {
            const key = v.keyName
            this.$set(this.form, key, this.detail[key])
          })
          this.checkList = []
          if (data.cost && data.cost.length) {
            this.checkList = []
            data.cost.map(v => {
              if (v) {
                this.checkList.push(v)
              }
            })
            this.$nextTick(() => {
              if (this.checkList.length) {
                this.form.cost = this.checkList.join(',')
              }
            })
          }
          if (data.fixed_pay && data.fixed_pay.length) {
            this.checkList2 = []
            data.fixed_pay.map(v => {
              if (v) {
                this.checkList2.push(v)
              }
            })
            console.log('checkList2', this.checkList2)
            this.$nextTick(() => {
              if (this.checkList2.length) {
                this.form.fixed_pay = this.checkList2.join(',')
                console.log({ ...this.form })
              }
            })
          }
          if (data.inspection && data.inspection.length) {
            // this.checkList3 = []
            data.inspection.map(v => {
              if (v && v != 1) {
                this.checkList3.push(v)
              }
            })
            this.$nextTick(() => {
              if (this.checkList3.length) {
                this.form.inspection = this.checkList3.join(',')
              }
            })
          }
          this.$forceUpdate()
          // console.log({ ...this.detail })
          // console.log({ ...this.form })
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSubmit() {
      console.log({ ...this.form });
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq() {
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        // userid: this.user.id,
      }
      const object = this.form
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getData()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getData()
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .tips {
      display: inline-block;
      margin: 0 0 0 45px;
      width: auto;
      min-width: 220px;
      height: 100%;
      font-size: 12px;
    }

    .el-input {
      width: 200px;
    }
  }

  // .el-textarea {
  //   width: 200px;
  // }

  .el-checkbox.is-disabled.is-checked {
    .el-checkbox__inner {
      background-color: #409EFF;
      border-color: #409EFF;
    }

    .el-checkbox__label {
      color: #606266;
    }
  }

  .item {
    .list {
      display: inline-block;
      min-width: 350px;
    }

    span.tips {
      display: inline-block;
    }
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
